<template>
  <el-form ref="form" size="mini" :model="form" class="bj-query-form bj-query-form-for-cal-height form" :rules="rules">
    <el-row :gutter="20" style="padding: 0 10px">
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.Client')" prop="clientCode">
          <!-- <BjSelectLov v-model="form.clientCode" :option-list="clientCodeList" :placeholder="$t('chooseText')" @change="getCategoryCodeList" /> -->
          <BjSelectLov v-model="form.clientCode" :option-list="clientCodeList" :placeholder="$t('chooseText')" />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.creditType')" prop="creditType">
          <BjSelectLov v-model="form.creditType" :option-list="creditTypeList" :placeholder="$t('chooseText')" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="padding: 0 10px">
      <el-col :span="8">
        <el-form-item :label="$t('billingPage.CreditType')" prop="GSTType">
          <BjSelectLov v-model="GSTType" :option-list="[{label:'Excl.GST',value:'Excl'},{label:'Incl.GST',value:'Incl'}]" :placeholder="$t('chooseText')" @change="chooseType" :clearable="false" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$t('billingPage.Credit')" prop="quantity">
          <BjInputMoney :disabled="GSTType == 'Incl'" v-model="form.quantity" :placeholder="$t('billingPage.Credit')" clearable @blur="getCreditGST"/>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$t('billingPage.CreditGST')" prop="inclQuantity">
          <BjInputMoney :disabled="GSTType == 'Excl'" v-model="form.inclQuantity" :placeholder="$t('billingPage.CreditGST')" clearable @blur="getInclQuantity"/> 
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="padding: 0 10px">
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.creditNoe')" prop="creditNoe">
          <BjSelectLov v-model="form.creditNoe" :option-list="STATUS_CREDITNOE_TRUE" :placeholder="$t('chooseText')" />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan" v-if="form.creditNoe">
        <el-form-item :label="$t('billingPage.ApplyWeek')" prop="year">
          <el-date-picker id="getWeekDate1" v-model="weekDataNow" :picker-options="pickerOptions"
            style="width: 100%" type="week" format="yyyy-WW" :clearable="false" :placeholder="$t('billingPage.ApplyWeek')">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.group')" prop="group">
          <BjSelectLov v-model="form.groupData" lov-code="BILL_CATEGORY_GROUP" @change="chooseGroups" />
        </el-form-item>
      </el-col> -->
      <!-- <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.Category')" prop="categoryCode">
          <BjSelectLov v-model="form.categoryCode" :option-list="categoryCodeList" :placeholder="$t('chooseText')" />
        </el-form-item>
      </el-col> -->
    </el-row>
    <el-row :gutter="20" style="padding: 0 10px">
      <el-col :span="24">
        <el-form-item :label="$t('billingPage.description')" prop="description">
          <BjInput v-model="form.description" type="textarea" autosize show-word-limit :maxlength="MAX_LENGTH.BILLMAX" :placeholder="$t('inputText')" />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
// import { billApi } from '@/api';
import { STATUS_CREDITNOE_TRUE } from '@/utils/constants';
export default {
  props: {
    clientCodeList: {
      type: Array,
      default: () => [],
    },
    // categoryCodeList: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  data() {
    const validate1 = (rule, value, callback) => {
      setTimeout(() => {
        if (!this.form.year) {
          callback(new Error(this.$t('chooseText')));
        } else{
          callback(console.log(this.form.year));
        }
      }, 300)
    };
    return {
      STATUS_CREDITNOE_TRUE,
      creditTypeList: [
        { label: 'Postage', value: 'Postage' },
        { label: 'Storage', value: 'Storage' },
        { label: 'Labour', value: 'Labour' },
      ],
      colSpan: 8,
      form: {
        clientCode: null,
        quantity: null,
        inclQuantity: null,
        year: null,
        // groupData: null,
        categoryCode: "Credit",
        description: null,
        creditNoe: false,
        creditType: '',
      },
      GSTType:'Excl',
      pickerOptions: {
        // 限制本周及以后的不可被选
        disabledDate(time) {
          const now = new Date();
          const day = now.getDay();
          const oneDayMs = 24 * 60 * 60 * 1000;
          const mondayTime = now.getTime() - (day - 1) * oneDayMs;
          return time.getTime() > mondayTime + 3600 * 1000 * 120;
        },
      },
      weekDataNow: null,
      rules: {
        clientCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        // categoryCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        // quantity: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        // inclQuantity: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        year: [{ required: true, validator: validate1, trigger: 'change' }],
        creditNoe: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        creditType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      },
    };
  },
  watch: {
    'weekDataNow'() {
      this.$nextTick(() => {
        this.form.year = this.form.creditNoe? document.querySelector('#getWeekDate1').value : null;
      });
    },
    'form.quantity'(val){
      if(!val || val == 'NaN'){
        this.form.inclQuantity = '0'
      }
    },
    'form.inclQuantity'(val){
      if(!val || val == 'NaN'){
        this.form.quantity = '0'
      }
    },
  },
  methods: {
    init(){
      this.weekDataNow = null
      this.form.year = null
    },
    // 选择是否含税
    chooseType(n,m){
      this.GSTType = n
    },
    // 计算含税价
    getCreditGST(){
      // 20250818/6755 澳洲的 GST 税率是10%，计算公式是，含税价= 不含税 * 1.1，保留两位小数
      this.form.inclQuantity = ((this.form.quantity - 0) * 1.1).toFixed(2)
    },
    // 计算含税价
    getInclQuantity(){
      // 20250818/6755 澳洲的 GST 税率是10%，计算公式是，含税价= 不含税 * 1.1，保留两位小数
      this.form.quantity = ((this.form.inclQuantity - 0) / 1.1).toFixed(2)
    },
    // getCategoryCodeList(val) {
    //   billApi.getAllAdditionalCharges({clientCode: val}).then(res => {
    //     this.categoryCodeList = res.data;
    //   });
    // },
    // chooseGroups(value){
    //   this.queryParams.group = value.join(',')
    // },
  }
};
</script>
